import React, { useState, useEffect } from 'react'
import * as SG from '../style/Styles'
import * as U from '../util/UrlHttp'
import * as UserService from '../services/User.service'
import * as TXT from '../util/Texts'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import * as LanguageService from '../services/Language.service'

export default function IconFlagSelector() {
  const [langs, setLangs] = useState<any[]>([])
  const [selectedLang, setSelectedLang] = useState<any>(null)
  const [openLangModal, setOpenLangModal] = useState(false)

  const getUniqueLanguages = (languagesList: any[]) => {
    if (!languagesList || !Array.isArray(languagesList)) return [];
    return languagesList.filter((v: any, i: number, a: any[]) => 
      a.findIndex((t: any) => t.id === v.id || t.name_lang.toLowerCase() === v.name_lang.toLowerCase()) === i
    );
  }

  const initializeLanguage = async (languagesList: any[]) => {
    const storedLang = localStorage.getItem('selected_language')
    let currentLang = null
    if (storedLang) {
      currentLang = JSON.parse(storedLang)
      setSelectedLang(currentLang)
    } else {
      const ptLang = languagesList.find((l: any) => 
        l.name_lang.toLowerCase().includes('portugues') || 
        l.name_lang.toLowerCase().includes('português') ||
        l.name_lang.toLowerCase().includes('brasil')
      )
      const defaultLang = ptLang || languagesList[0]
      if (defaultLang) {
        currentLang = defaultLang
        setSelectedLang(defaultLang)
        localStorage.setItem('selected_language', JSON.stringify(defaultLang))
      }
    }

    if (currentLang && !localStorage.getItem('selected_language_texts')) {
      try {
        const result = await LanguageService.GetLanguage(currentLang.id)
        if (result.data && result.data.status && result.data.language.texts) {
          localStorage.setItem('selected_language_texts', JSON.stringify(result.data.language.texts))
          window.location.reload()
        }
      } catch (err) {
        console.warn('Erro ao inicializar textos do idioma:', err)
      }
    }
  }

  const handleSelectLang = async (lang: any) => {
    setSelectedLang(lang)
    localStorage.setItem('selected_language', JSON.stringify(lang))
    
    try {
      const result = await LanguageService.GetLanguage(lang.id)
      if (result.data && result.data.status && result.data.language.texts) {
        localStorage.setItem('selected_language_texts', JSON.stringify(result.data.language.texts))
      } else {
        localStorage.removeItem('selected_language_texts')
      }
    } catch (err) {
      console.warn('Erro ao carregar traduções do idioma selecionado:', err)
      localStorage.removeItem('selected_language_texts')
    }

    setOpenLangModal(false)
    window.location.reload()
  }

  useEffect(() => {
    const loadConfig = async () => {
      const storedLangs = localStorage.getItem('app_languages')
      if (storedLangs) {
        const parsed = JSON.parse(storedLangs)
        const unique = getUniqueLanguages(parsed)
        setLangs(unique)
        initializeLanguage(unique)
      }

      try {
        const result = await UserService.GetConfig()
        if (result && result.data && result.data.status) {
          localStorage.setItem('app_countries', JSON.stringify(result.data.countries))
          localStorage.setItem('app_languages', JSON.stringify(result.data.languages))
          const unique = getUniqueLanguages(result.data.languages)
          setLangs(unique)
          initializeLanguage(unique)
        }
      } catch (error) {
        console.warn('Erro ao atualizar configurações:', error)
      }
    }
    loadConfig()
  }, [])

  return (
    <>
      <SG.IconFlag 
        className='iconFlagG' 
        src={selectedLang ? `${selectedLang.icon}` : `${U.BASE_BACK}${U.ICON_BR}`} 
        alt={selectedLang ? selectedLang.name_lang : TXT.LANGUAGE} 
        onClick={() => setOpenLangModal(true)}
        style={{ cursor: 'pointer' }}
        onError={(e: any) => {
          e.currentTarget.src = `${U.BASE_BACK}${U.ICON_BR}`;
        }}
      />

      <Dialog 
        open={openLangModal} 
        onClose={() => setOpenLangModal(false)}
        PaperProps={{
          style: {
            borderRadius: 16,
            padding: '15px 10px',
            width: 480,
            maxWidth: '95vw',
            zIndex: 10000
          }
        }}
      >
        <DialogTitle style={{ fontWeight: 'bold', textAlign: 'center', paddingBottom: 15, fontSize: 18 }}>
          {TXT.SELECT_LANGUAGE}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 15, justifyContent: 'center' }}>
            {langs.length > 0 ? (
              langs.map((l: any) => (
                <div
                  key={l.id}
                  onClick={() => handleSelectLang(l)}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '12px 8px',
                    borderRadius: 12,
                    cursor: 'pointer',
                    width: 'calc(25% - 12px)',
                    boxSizing: 'border-box',
                    backgroundColor: selectedLang?.id === l.id ? 'rgba(25, 112, 210, 0.08)' : 'transparent',
                    transition: 'all 0.2s ease',
                    border: selectedLang?.id === l.id ? '2px solid #1976d2' : '2px solid transparent'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedLang?.id !== l.id) {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.03)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedLang?.id !== l.id) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'none';
                    }
                  }}
                >
                  <img
                    src={`${l.icon}`}
                    alt={l.name_lang}
                    onError={(e: any) => {
                      e.currentTarget.src = `${U.BASE_BACK}${U.ICON_BR}`;
                    }}
                    style={{ width: 40, height: 26, marginBottom: 8, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                  />
                  <span style={{ fontSize: 12, fontWeight: selectedLang?.id === l.id ? 'bold' : 'normal', textAlign: 'center', color: '#333' }}>
                    {l.name_lang}
                  </span>
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: 20 }}>{TXT.LOADING_LANGUAGES}</div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
